import React from 'react';
import {
  InfoIcon,
  CheckCircleIcon,
  XCircleIcon,
  WarningIcon,
  WarningCircleIcon,
  EnvelopeIcon,
  EnvelopeSimpleIcon,
  SealCheckIcon,
  CaretDownIcon,
  ArrowRightIcon,
  QuestionIcon,
  BookmarkSimpleIcon,
  NewspaperClippingIcon,
  AppWindowIcon,
  CalendarCheckIcon,
  PackageIcon,
  BrowsersIcon,
  LockersIcon,
  LampIcon,
  TextAaIcon,
  MicrophoneIcon,
  CaretRightIcon,
  CaretUpIcon,
  ListIcon,
  ChatCenteredTextIcon,
  HandHeartIcon,
  HeartIcon,
  UserIcon,
  LockKeyIcon,
  BookmarkIcon,
  UserCircleIcon,
  UserListIcon,
  PencilSimpleLineIcon,
  CheckIcon,
  XIcon,
  BellRingingIcon,
  SwapIcon,
  ArrowSquareOutIcon,
  ChatsCircleIcon,
  PlusIcon,
  ClockCounterClockwiseIcon,
  PhoneIcon,
  PhoneSlashIcon,
  CopySimpleIcon,
  AtIcon,
  PrinterIcon,
  ArrowLeftIcon,
  HeadphonesIcon,
  SquaresFourIcon,
  ListBulletsIcon,
} from '@phosphor-icons/react';

import css from './PhosphorIcon.module.scss';

/**
 * Map icon names to components.
 * Add new icons here if needed.
 */
const ICON_MAP = {
  info: InfoIcon,
  checkCircle: CheckCircleIcon,
  xCircle: XCircleIcon,
  warning: WarningIcon,
  warningCircle: WarningCircleIcon,
  envelope: EnvelopeIcon,
  envelopeSimple: EnvelopeSimpleIcon,
  sealCheck: SealCheckIcon,
  caretDown: CaretDownIcon,
  caretRight: CaretRightIcon,
  caretUp: CaretUpIcon,
  arrowRight: ArrowRightIcon,
  arrowLeft: ArrowLeftIcon,
  question: QuestionIcon,
  bookmarkSimple: BookmarkSimpleIcon,
  newsPaperClipping: NewspaperClippingIcon,
  appWindow: AppWindowIcon,
  calendarCheck: CalendarCheckIcon,
  package: PackageIcon,
  browsers: BrowsersIcon,
  lockers: LockersIcon,
  lamp: LampIcon,
  textAa: TextAaIcon,
  microphone: MicrophoneIcon,
  list: ListIcon,
  chatCenteredText: ChatCenteredTextIcon,
  handHeart: HandHeartIcon,
  heart: HeartIcon,
  user: UserIcon,
  lockKey: LockKeyIcon,
  bookmark: BookmarkIcon,
  userCircle: UserCircleIcon,
  userList: UserListIcon,
  pencilSimpleLine: PencilSimpleLineIcon,
  check: CheckIcon,
  x: XIcon,
  'bell-ringing': BellRingingIcon,
  swap: SwapIcon,
  arrowSquareOut: ArrowSquareOutIcon,
  chatsCircle: ChatsCircleIcon,
  plus: PlusIcon,
  clockCounterClockwise: ClockCounterClockwiseIcon,
  phone: PhoneIcon,
  phoneSlash: PhoneSlashIcon,
  copySimple: CopySimpleIcon,
  at: AtIcon,
  printer: PrinterIcon,
  headphones: HeadphonesIcon,
  squarefour: SquaresFourIcon,
  listbullet: ListBulletsIcon
};


const PhosphorIcon = ({
  name = 'info',
  size = 24,
  color = '#000',
  weight = 'regular',
  className = '',
  inline = false,
  ariaHidden = false,
  dataExpanded,
}) => {
  const IconComponent = ICON_MAP[name] || InfoIcon;

  const sizeStyle = {
    width: `${size}px`,
    minWidth: `${size}px`,
    height: `${size}px`,
  };

  return (
    <span
      className={[
        css.phosphorIcon,
        inline ? css.inline : '',
        className,
      ].join(' ')}
      style={sizeStyle}
      aria-hidden={ariaHidden}
      data-expanded={dataExpanded}
    >
      <IconComponent color={color} size={size} weight={weight} />
    </span>
  );
};

export default PhosphorIcon;
